import Checkbox from './ExpoCheckbox';
export * from './Checkbox.types';
export { Checkbox };
/** @hidden */
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map